import ReactDOM from 'react-dom/client';
import App from './app/App';
import * as Sentry from '@sentry/react';
import mixpanel from 'mixpanel-browser';
import { v4 as uuidv4 } from 'uuid';

Sentry.init({
  enabled: process.env.NODE_ENV === 'production',
  dsn: 'https://933e0ef8ae68d7f1290643ba4ff10421@o4507821238714368.ingest.us.sentry.io/4508018212798464',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost'],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

mixpanel.init('23613a410f23fb10995e93c3adac9e32', {
  debug: true,
  track_pageview: true,
  persistence: 'localStorage',
});

const USER_ID_KEY = '__apriori_staking_user_id__';

// generate and save a unique identifier for the user in localStorage if not there already
if (!localStorage.getItem(USER_ID_KEY)) {
  localStorage.setItem(USER_ID_KEY, uuidv4());
}

mixpanel.identify(localStorage.getItem(USER_ID_KEY) || '');

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
